import { useWheelsTvSourceQuery } from 'lib/api/wheelsTv/useWheelsTvSourceQuery';
import { WTVListItem } from 'lib/api/wheelsTv/useWheelsTvVideosQuery';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { WheelsTVTable } from '../wtvModal/WheelsTVTable';
import { VideoSourceType, ISourceType } from './types';

const Content = styled.div`
  padding-top: 32px;
`;

interface Props {
  selectWheelsTvVideo?: (url: string, source: ISourceType) => void;
}

export const TabWheelsTV = ({ selectWheelsTvVideo }: Props) => {
  const [wtvVideoId, setWtvVideoId] = useState('');
  const [wtvId, setwtvId] = useState<number | null>(null);
  const [videoSource, setVideoSource] = useState('');
  useWheelsTvSourceQuery({ wtvVideoId, setVideoSource });
  const handleOnSelectVideo = (wtvItem: WTVListItem) => {
    const wtvVideoId = wtvItem?.wtvVideoId;
    const wtvId = wtvItem?.wtvId;
    if (wtvVideoId && wtvId) {
      setWtvVideoId(wtvVideoId);
      setwtvId(wtvId);
    }
  };
  useEffect(() => {
    if (videoSource && wtvId) {
      selectWheelsTvVideo?.(videoSource, {
        sourceType: VideoSourceType.WHEELS_TV,
        sourceId: wtvId,
      });
    }
  }, [videoSource]);

  return (
    <Content>
      <WheelsTVTable
        onSelectVideo={handleOnSelectVideo}
        showAddToCovideo={false}
      />
    </Content>
  );
};
